(ns nosco.shared.avatar
  (:require [clojure.string :as str]
            [nosco.colors :as colors]
            [nosco.images :as images]))

(defn- classnames
  [& values]
  (->> values
       (mapcat (fn [value]
                 (cond
                   (nil? value) []
                   (string? value) [value]
                   (sequential? value) value
                   :else [(str value)])))
       (remove str/blank?)
       (str/join " ")))

(defn- user-seed [user]
  (or (:id user)
      (:email user)
      (:givenName user)
      "avatar"))

(defn- given-name [user]
  (or (:givenName user) ""))

(defn- family-name [user]
  (or (:familyName user) ""))

(defn avatar-tag [{:keys [href user]}]
  (if (or href (:href user)) :a :div))

(defn avatar-attrs [{:keys [href inline outline size user]}]
  (let [href (or href (:href user))]
    (cond-> {:class (classnames "nosco-avatar"
                                (when inline "d-inline-block")
                                (when (= :xsm size) "nosco-avatar--xsm")
                                (when (= :sm size) "nosco-avatar--sm")
                                (when (= :default size) "nosco-avatar--default")
                                (when (= :lg size) "nosco-avatar--lg")
                                (when (= :xlg size) "nosco-avatar--xlg")
                                (when (= :xxlg size) "nosco-avatar--xxlg")
                                (when outline "nosco-avatar--has-outline"))}
      href (assoc :href href))))

(defn avatar-content [{:keys [size user]}]
  (let [image (:image user)]
    (if (and image (not= image "/img/thumb-undefined.png"))
      [:img
       {:class "nosco-avatar__image"
        :src (images/thumbnail-url image)}]
      [:div
       {:class "nosco-avatar__initials"
        :style {:background-color (colors/data-color-for (user-seed user))}}
       (first (given-name user))
       (when (and (not= :xsm size) (not= :sm size))
         (first (family-name user)))])))
